'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var GraphqlVoyagerPage = (_temp = _class = function (_Component) {
  _inherits(GraphqlVoyagerPage, _Component);

  function GraphqlVoyagerPage() {
    _classCallCheck(this, GraphqlVoyagerPage);

    return _possibleConstructorReturn(this, (GraphqlVoyagerPage.__proto__ || Object.getPrototypeOf(GraphqlVoyagerPage)).apply(this, arguments));
  }

  _createClass(GraphqlVoyagerPage, [{
    key: 'introspectionProvider',
    value: function introspectionProvider(query) {
      return fetch(window.location.origin + '/api/', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: query
        })
      }).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (typeof window === "undefined") {
        return null;
      }

      var Voyager = require('@prisma-cms/graphql-voyager').Voyager;

      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('link', {
        rel: 'stylesheet',
        href: 'https://cdn.jsdelivr.net/npm/graphql-voyager/dist/voyager.css'
      }), _react2.default.createElement('style', {
        dangerouslySetInnerHTML: {
          __html: '\n              #root{\n                height: 100vh;\n                display: flex;\n                flex-direction: column;\n              }\n\n              #Renderer--body {\n                overflow: hidden;\n                flex: 1 0;\n              }\n            '
        }
      }), _react2.default.createElement(Voyager, {
        introspection: this.introspectionProvider
      }));
    }
  }]);

  return GraphqlVoyagerPage;
}(_react.Component), _class.propTypes = {}, _temp);
exports.default = GraphqlVoyagerPage;
module.exports = exports['default'];